import { SERVER_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import {
  SECTION_SCORE_REPORT_FULL_HEADER_MAP,
  SECTION_SCORE_REPORT_REDUCED_HEADER_MAP,
  SectionScoreTableRow,
} from "api/api-types-assessment";
import { withApiErrorReporting } from "utils/api-errors";
import { CSVData } from "utils/file";
import { translateCSVHeaders } from "utils/reporting";

export async function serverGetSectionScoreTable(
  sectionId: string,
): Promise<SectionScoreTableRow[]> {
  return withApiErrorReporting("serverGetSectionScoreTable", async () => {
    const response = await serverApi.get<SectionScoreTableRow[]>(
      `${SERVER_API_PATH}/assessment/section_scores/table/`,
      { params: { section_id: sectionId } },
    );
    return response.data;
  });
}

export async function serverGetSectionScoreReport(params: {
  term_id?: string;
  course_id?: string;
  section_id?: string;
}): Promise<CSVData> {
  return withApiErrorReporting("serverGetSectionScoreReport", async () => {
    const response = await serverApi.get<CSVData>(
      `${SERVER_API_PATH}/assessment/section_scores/report/`,
      { params },
    );
    const headerMap = params.section_id
      ? SECTION_SCORE_REPORT_REDUCED_HEADER_MAP
      : SECTION_SCORE_REPORT_FULL_HEADER_MAP;
    return translateCSVHeaders(response.data, headerMap);
  });
}
